import Comment from './Comment'
import CommentInput from './components/CommentInput'
import CommentBubble from './components/CommentBubble'

export { CommentInput, CommentBubble }
export default Comment